import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
const initSustainabilitySections = () => {
    [...document.querySelectorAll('.sustainability-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initSustainabilitySection(item));
};

const initSustainabilitySection = (section) => {
    section.dataset.init = true;
    const slider = section.querySelector('.sustainability-items');
    const swiper = new Swiper(slider, {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 20,
        autoHeight: false,
        loop: true,
    });
    section.addEventListener('click', e => {
        const prevButton = e.target.closest('.swiper-button-prev');
        if(prevButton) {
            swiper.slidePrev();
            return;
        }
        const nextButton = e.target.closest('.swiper-button-next');
        if(nextButton) {
            swiper.slideNext();
            return;
        }
    })
};

export { initSustainabilitySections };